import React from 'react'
import axios from 'axios'
import {
  TextField,
  Select,
  MenuItem,
  IconButton,
  FormControl
} from '@material-ui/core'
import { Save } from '@material-ui/icons'

const COST_TYPES = ['labor', 'equipment', 'material', 'subcontract', 'disposal']

const QuickPriceInput = ({ lineItem, url, onSave }) => {
  const [costType, setCostType] = React.useState('material')
  const [unitCost, setUnitCost] = React.useState('')
  const [saving, setSaving] = React.useState(false)

  const handleSave = () => {
    if (!unitCost || !lineItem) return
    setSaving(true)
    axios.post(`${url}/api/bid-estimation/line-items/${lineItem._id}/components`, {
      costType,
      description: `${costType} - quick price`,
      componentQty: lineItem.quantity || 0,
      quickUnitCost: parseFloat(unitCost) || 0
    }).then(() => {
      setSaving(false)
      setUnitCost('')
      onSave()
    }).catch(err => {
      console.error(err)
      setSaving(false)
    })
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginLeft: 8 }}>
      <FormControl size="small" variant="outlined" style={{ minWidth: 100 }}>
        <Select
          value={costType}
          onChange={e => setCostType(e.target.value)}
          style={{ fontSize: '0.8rem', height: 32 }}
        >
          {COST_TYPES.map(t => (
            <MenuItem key={t} value={t} style={{ fontSize: '0.8rem', textTransform: 'capitalize' }}>{t}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        size="small"
        variant="outlined"
        placeholder="$/unit"
        type="number"
        value={unitCost}
        onChange={e => setUnitCost(e.target.value)}
        style={{ width: 90 }}
        inputProps={{ style: { fontSize: '0.8rem', padding: '6px 8px' } }}
      />
      <IconButton size="small" onClick={handleSave} disabled={saving || !unitCost} color="primary">
        <Save fontSize="small" />
      </IconButton>
    </span>
  )
}

export default QuickPriceInput
